import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Trash2 } from "lucide-react"
import { api } from "../../api/client"
import { useApp } from "../../state/AppState"
import { Button, Modal } from "../ui"

/** Deleting a project: one question, one button. */
export function DeleteProjectDialog({ project, open, onClose }) {
	const { refreshProjects, toast } = useApp()
	const navigate = useNavigate()

	const [busy, setBusy] = useState(false)

	// Reopening after a failed attempt should not arrive stuck mid-spin.
	useEffect(() => {
		if (open) setBusy(false)
	}, [open])

	if (!project) return null

	const name = project.name || ""

	const remove = async () => {
		if (busy) return
		setBusy(true)
		try {
			await api.deleteProject(project.project_id)
			// Out of the sidebar before the page it is on goes away, so there
			// is never a frame showing a link to a project that has gone.
			await refreshProjects()
			navigate("/app", { replace: true })
			toast(`"${name}" deleted`, "info")
		} catch (cause) {
			toast(cause.message, "error")
			setBusy(false)
		}
	}

	return (
		<Modal
			open={open}
			onClose={busy ? undefined : onClose}
			size="sm"
			title={`Delete "${name}"?`}
			footer={
				<>
					<Button onClick={onClose} disabled={busy}>
						Cancel
					</Button>
					<Button variant="danger" icon={Trash2} onClick={remove} busy={busy}>
						Delete project
					</Button>
				</>
			}
		>
			<p className="text-[0.8125rem] leading-relaxed text-ink-600">
				The project and everything raised in it will be removed.
			</p>
		</Modal>
	)
}
